(function() {
    'use strict';

    angular
        .module('completeAir')
        .controller('specialConnectionCtrl', specialConnectionCtrl)
        .controller('newSpecialConnectionCtrl', newSpecialConnectionCtrl)
        .controller('deleteSpecialConnectionCtrl', deleteSpecialConnectionCtrl);

    specialConnectionCtrl.$inject = ['$stateParams', 'linkService','tabAdminFlights','connections',
        'datePickerService','$timeout','dateService'];
    newSpecialConnectionCtrl.$inject = ['linkService','tabAdminFlights','specialConnectionService','dialogService','$stateParams','datePickerService','flightService','$timeout','dateService', 'AuthServerProvider'];
    deleteSpecialConnectionCtrl.$inject = ['specialConnectionService', '$uibModalInstance', '$stateParams', 'AuthServerProvider'];

    function specialConnectionCtrl($stateParams,linkService,tabAdminFlights,connections,datePickerService,$timeout,dateService) {
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabAdminFlights;
        vm.connections = connections;
        vm.radioFlight = 'list';
        vm.flights = [];
        vm.beforeYesterday = new Date();
        vm.beforeYesterday = dateService.addDays(vm.beforeYesterday, -3);
        vm.beforeYesterday.setHours(0,0,0);

        vm.dateConnection = {
            'date': ($stateParams.date != "") ? new Date(parseInt($stateParams.date)) : new Date()
        };
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.beforeYesterday
            },
            closed: function(args) {
                if(args.closeDate != ""){
                    vm.changeDay();
                }
            }
        };
        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.changeDay = function(){
            $timeout(function(){
                if(vm.radioFlight == "list"){
                    var date = vm.dateConnection.date;
                    if(date != undefined){
                        var dateTime = date.getTime();
                        linkService.reloadRoute(linkService.getCurrentRouteName(), {date: dateTime})
                    }
                }
            }, 100);
        }

    }

    function newSpecialConnectionCtrl(linkService,tabAdminFlights,specialConnectionService,dialogService,$stateParams,
                                      datePickerService,flightService,$timeout,dateService, AuthServerProvider){
        var vm = this;
        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;
        vm.datePickerService = datePickerService;
        vm.tomorrow = new Date();
        vm.tomorrow.setDate(vm.tomorrow.getDate() - 60);

        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.dateConnection = {
            //'date': ($stateParams.date != "") ? new Date(parseInt($stateParams.date)) : new Date()
            'date': new Date()
        };
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.tomorrow
            },
            closed: function(args) {
                if(args.closeDate != ""){
                    vm.changeDay();
                }
            }
        };
        /*
        * vm.datepickerFrom = {
         dateFormat: 'dd/MM/yyyy',
         datepickerOptions: {
         showWeeks: false,
         minDate: vm.tomorrow
         },
         closed: function(args) {
         var valueDate = args.closeDate;
         vm.datepickerTo.datepickerOptions.minDate = valueDate;
         }
         };
        * */
        vm.openCalendar = function(index){
            vm.connection.datePickerOpenStatus[index].open = true;
        }


        vm.connection = {
            "originId": "",
            "origin": "",
            "destinyId": "",
            "destiny": "",
            "minimumStay": 0,
            "maximumStay": 0,
            "maximumStops": 0,
            "departureFlightConnections" :[],
            "flights" : [],
            'datePickerOpenStatus': []
        };

        vm.addSegment = function(isValid,connection){
            if(isValid){
                if(connection.originId == "" || connection.originId == undefined ) {
                    dialogService.dialogRequiredError('air.adminConnection.origin');
                    vm.connection.origin = "";
                }else{
                    if(connection.destinyId == "" || connection.destinyId == undefined) {
                        dialogService.dialogRequiredError('air.adminConnection.destiny');
                        vm.connection.destiny = "";
                    }else {
                        if (vm.connection.departureFlightConnections.length===0){
                            vm.connection.departureFlightConnections.push({
                                "origin": connection.origin,
                                "originId":connection.originId,
                                "flights":[],
                                "rowDisabled":false
                            });
                            vm.connection.datePickerOpenStatus.push({'open': false});
                        }else{
                            var pos = vm.connection.departureFlightConnections.length;
                            vm.connection.departureFlightConnections[pos-1].rowDisabled = true;
                            var departureFlightConnection = vm.connection.departureFlightConnections[pos -1];
                            vm.connection.departureFlightConnections.push({
                                "origin": departureFlightConnection.destiny,
                                "originId":departureFlightConnection.destinyId,
                                "flights":[],
                                "rowDisabled":false
                            });
                            vm.connection.datePickerOpenStatus.push({'open': false});
                            var aux = new Date(vm.connection.departureFlightConnections[pos-1].departureDate);
                            vm.tomorrow.setDate(aux.getDate()-1);
                        }
                    }
                }
            }else{
                if(connection.originId == "" || connection.originId == undefined ) {
                    dialogService.dialogRequiredError('air.adminConnection.origin');
                    vm.connection.origin = "";
                }else {
                    if (connection.destinyId == "" || connection.destinyId == undefined) {
                        dialogService.dialogRequiredError('air.adminConnection.destiny');
                        vm.connection.destiny = "";
                    } else {
                        if (connection.minimumStay == "" || connection.minimumStay == undefined) {
                            dialogService.dialogRequiredError('air.adminConnection.minimumStay');
                        } else {
                            if (connection.maximumStay == "" || connection.maximumStay == undefined) {
                                dialogService.dialogRequiredError('air.adminConnection.maximumStay');
                            } else {
                                if (connection.maximumStops == "" || connection.maximumStops == undefined) {
                                    dialogService.dialogRequiredError('air.adminConnection.maximumStops');
                                }else{
                                    var pos = vm.connection.departureFlightConnections.length -1;
                                    if(vm.connection.departureFlightConnections[pos].destinyId == undefined
                                        || (vm.connection.departureFlightConnections[pos].destinyId+"").trim() == ""){
                                        dialogService.dialogRequiredError('air.adminConnection.destiny');
                                        vm.connection.departureFlightConnections[pos].destiny = "";
                                        vm.connection.departureFlightConnections[pos].departureDate = "";
                                    }else{
                                        if(vm.connection.departureFlightConnections[pos].departureDate == undefined
                                            || (vm.connection.departureFlightConnections[pos].departureDate+"").trim() == ""){
                                            dialogService.dialogRequiredError('air.adminConnection.departureDate');
                                            vm.connection.departureFlightConnections[pos].departureDate = "";
                                        }else{
                                            dialogService.dialogRequiredError('air.adminConnection.flight');
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        vm.deleteConnectionList =  function(){
            vm.connection.departureFlightConnections = [];
        }

        vm.deleteSegmentInformation = function(){
            var pos = vm.connection.departureFlightConnections.length -1;
            vm.connection.departureFlightConnections[pos].destinyId = "";
            vm.connection.departureFlightConnections[pos].departureDate = "";
            vm.connection.departureFlightConnections[pos].arrivalDate = "";
            vm.connection.departureFlightConnections[pos].flight = "";
            vm.connection.departureFlightConnections[pos].departureTime = "";
            vm.connection.departureFlightConnections[pos].arrivalTime = "";
            vm.connection.departureFlightConnections[pos].flights = [];
        }

        vm.deleteSegment = function(){
            var pos = vm.connection.departureFlightConnections.length;
            vm.connection.departureFlightConnections.splice((pos-1) , 1);
            pos = vm.connection.departureFlightConnections.length;
            vm.connection.departureFlightConnections[pos-1].rowDisabled = false;
            if(pos == 1){
                var auxDate = new Date();
                vm.tomorrow.setDate(auxDate.getDate() -1);
            }else{
                var auxDate = new Date(vm.connection.departureFlightConnections[pos-2].departureDate);
                vm.tomorrow.setDate(auxDate.getDate() -1);
            }
        }
        vm.changeDay = function(){
            var pos = vm.connection.departureFlightConnections.length -1;
            var date = vm.connection.departureFlightConnections[pos].departureDate;
            var dateAux = date;
            vm.connection.departureFlightConnections[pos].flights = [];
            vm.connection.departureFlightConnections[pos].flight = "";
            vm.connection.departureFlightConnections[pos].departureTime = "";
            vm.connection.departureFlightConnections[pos].arrivalTime = "";
            if(date != undefined){
                var dateTime = dateAux.getTime();
                var destinyId = vm.connection.departureFlightConnections[pos].destinyId;
                var originId = vm.connection.departureFlightConnections[pos].originId;
                if(destinyId != undefined && (destinyId+"").trim() != ""){
                    if(vm.connection.departureFlightConnections.length>1) {
                        var dateArrival = (dateService.addMinutes(new Date(vm.connection.departureFlightConnections[pos - 1].arrivalTime), vm.connection.minimumStay)).getTime();
                        if (dateTime < dateArrival) {
                            dateTime = dateArrival
                        }
                    }
                    flightService.getFlightByDepartureDateAndSegment(dateTime, originId, destinyId)
                        .then(function (response) {
                            vm.connection.departureFlightConnections[pos].flights = response;

                        });
                }else{
                    dialogService.dialogRequiredError('air.adminConnection.destiny');
                    vm.connection.departureFlightConnections[pos].destiny = "";
                    vm.connection.departureFlightConnections[pos].departureDate = "";
                }
            }
        }

        vm.changeModel = function(){
            var index = vm.connection.departureFlightConnections.length -1;
            var flight = vm.connection.departureFlightConnections[index].flight;
            if(flight != undefined) {
                vm.connection.departureFlightConnections[index].departureFlightId = vm.linkService.getLinkId(flight._embedded.departureflights[0]._links.self.href);
                vm.connection.departureFlightConnections[index].departureTime = dateService.getDateTimeByDateZone(flight._embedded.departureflights[0].departureDate);
                vm.connection.departureFlightConnections[index].arrivalTime = dateService.getDateTimeByDateZone(flight._embedded.departureflights[0].arrivalDate);
                vm.connection.departureFlightConnections[index].order = index + 1;
                if (index == 0) {
                    vm.connection.departureDate = dateService.getDateTimeByDateZone(flight._embedded.departureflights[0].departureDate);
                    vm.connection.arrivalDate = dateService.getDateTimeByDateZone(flight._embedded.departureflights[0].arrivalDate);
                } else {
                    vm.connection.arrivalDate = dateService.getDateTimeByDateZone(flight._embedded.departureflights[0].arrivalDate);
                }
            }
        }

        vm.saveSpecialConnection = function(isValid,connection){
            if(isValid){
                connection.originAirportId=connection.originId;
                connection.destinyAirportId=connection.destinyId;
                specialConnectionService.saveSpecialConnection(connection, vm.userAccount.userName)
                    .then(function(){
                        linkService.reloadRoute('specialConnections');
                    });
            }
        }

        vm.validateConnection = function(){
            var length = vm.connection.departureFlightConnections.length;
            if(length >1 ){ // && length <= vm.connection.maximumStops
                if(vm.connection.destinyId == vm.connection.departureFlightConnections[length-1].destinyId){
                    var auxFlightId = vm.linkService.getLinkId(vm.connection.departureFlightConnections[0].flight._links.self.href);
                    var band = true;
                    for(var i=1; i<length; i++){
                        if(vm.connection.departureFlightConnections[i].flight != undefined && vm.connection.departureFlightConnections[i].flight != ""){
                            if(auxFlightId != vm.linkService.getLinkId(vm.connection.departureFlightConnections[i].flight._links.self.href)){
                                band = false;
                                break;
                            }
                        }
                    }
                    if(band){
                        return false;
                    }

                }else{
                    return  false;
                }
            }else{
                return false;
            }
            return true;
        }
    }

    function deleteSpecialConnectionCtrl(specialConnectionService, $uibModalInstance, $stateParams, AuthServerProvider){
        var vm = this;
        vm.connectionId = $stateParams.connectionId;
        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.deleteSpecialConnection = function(){
            specialConnectionService.deleteSpecialConnection(vm.connectionId, vm.userAccount.userName)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
